import React, { useState } from "react";
import PropTypes from 'prop-types';
import classNames from "classnames";
import { Collapse } from 'reactstrap';

import MaterialIcon from "shared/react_components/MaterialIcon";
import TruncateTextWithTooltip from "shared/react_components/TruncateTextWithTooltip";

import {
  accordion,
  accordionTitle,
  accordionIcon,
  accordionContent
} from "./Accordion.module.scss";

const Accordion = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <div>
      <div className={classNames("d-flex text-left", accordion)} onClick={toggle}>
        <TruncateTextWithTooltip className={accordionTitle}>
          {title}
        </TruncateTextWithTooltip>
        <MaterialIcon name={isOpen ? "expand_less" : "expand_more"} className={accordionIcon} />
      </div>
      <Collapse isOpen={isOpen} className={accordionContent}>
        {children}
      </Collapse>
    </div>
  );
};

Accordion.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

export default Accordion;
